import { isMobile } from 'shared/utils/is-mobile';

export const __isMobile = isMobile();